// extracted by mini-css-extract-plugin
export default {"datepickerInput":"StopRentingAssetForm_datepickerInput__jxW90"};